export const moveLeadingEmojisToEnd = (str: string) => {
  // biome-ignore lint/complexity/useRegexLiterals: es5 fix
  // biome-ignore lint/suspicious/noUselessEscapeInString: es5 fix
  const regex = new RegExp('^(\\p{Emoji}+)\s*(.*)', 'u');
  const match = str.match(regex);

  if (!match) return str;

  const [, emojis, rest] = match;
  return rest.trimStart() + ' ' + emojis;
};
